module.exports = __webpack_public_path__ + "static/media/arbre-violet.0a1337d9.png";